import axios from "axios";
import { SCORING_BACKEND_ROOT, TRAVA_BACKEND_ROOT, TRAVA_NFT_BACKEND_ROOT } from "src/configs/constance";

export const defaultHeader = { Accept: "application/json", "Content-Type": "application/json" };

function responseBody(res) {
  return res.data;
}

export default class ApiQuery {
  constructor(rootUrl, config) {
    this.rootUrl = rootUrl;
    this.config = config ? { ...config, ...{ headers: defaultHeader } } : { headers: defaultHeader };
  }

  async get(url, config) {
    return await axios.get(`${this.rootUrl}${url}`, { ...config, ...this.config }).then(responseBody);
  }

  async post(url, data, config) {
    return await axios.post(`${this.rootUrl}${url}`, data, { ...config, ...this.config }).then(responseBody);
  }

  async put(url, data, config) {
    return await axios.put(`${this.rootUrl}${url}`, data, { ...config, ...this.config }).then(responseBody);
  }

  async del(url, config) {
    return await axios.delete(`${this.rootUrl}${url}`, { ...config, ...this.config }).then(responseBody);
  }
}

export const TravaApiQuery = new ApiQuery(TRAVA_BACKEND_ROOT);
export const TravaNFTApiQuery = new ApiQuery(TRAVA_NFT_BACKEND_ROOT);
export const ScoringApiQuery = new ApiQuery(SCORING_BACKEND_ROOT);
